import type { I18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";
import type { MenuItem } from "@/types/menu-item";
import type { MenuItemInitialValue } from "./CreateMenuItemDialog";

/**
 * The saved menu item, as the form wants it.
 *
 * A menu item links one plated recipe (T-904). Items created before that may
 * carry several, so the plate is preferred over whatever happens to be first:
 * opening one of those on its dressing would leave the form offering to save a
 * menu item the API now refuses.
 *
 * It lives beside the dialog rather than inside it so the dialog module keeps
 * exporting components only (react-refresh).
 */
export function toMenuItemInitialValue(item: MenuItem, i18n: I18n): MenuItemInitialValue {
  const member = item.recipes.find((r) => r.recipe?.recipeType === "PLATED") ?? item.recipes[0];
  return {
    id: item.id,
    name: item.name,
    menuId: item.menuId,
    price: item.price != null ? Number(item.price) : null,
    categoryId: item.categoryId ?? null,
    category: item.menuCategory?.name ?? item.category ?? null,
    isAvailable: item.isAvailable,
    conceptIds: item.concepts?.map((c) => c.companyId),
    dish: member
      ? {
          recipeId: member.recipeId,
          name: member.recipe?.name ?? i18n._(msg`Recipe #${member.recipeId}`),
          unitPrice: member.recipe?.targetSellingPrice,
        }
      : undefined,
  };
}
